import { render, staticRenderFns } from "./contactUsTab.vue?vue&type=template&id=573c3fae&"
import script from "./contactUsTab.vue?vue&type=script&lang=js&"
export * from "./contactUsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports